module.exports = __webpack_public_path__ + "static/media/2.6dc56107.png";